import { useState } from "react";
import { components } from 'react-select';
import { getAllData, verifytoken } from "../../services/ApiCallingUserServices";
import { checkIsArray, checkIsPlainObject } from "./CommonValidation";
import { GetLocalStorage } from "./Session";

export const getcountrystatecity = async () => {
    const locations = { cityData: [], stateData: [], regionData: [], countryData: [], subContinentData: [], continentData: [], genderData: [] }

    let statusoftoken = await verifytoken();
    if (statusoftoken) {
        try {
            const countrystatecity = await getAllData('/midoffice/v1/getcountrystatecity');
            if (countrystatecity?.status) {
                const cityData = countrystatecity?.data?.cityData?.map((obj: any) => {
                    obj.label = obj?.City
                    obj.value = obj?.LocationId
                    return obj;
                }) ?? [];
                const stateData = countrystatecity?.data?.stateData?.map((obj: any) => {
                    obj.label = obj?.StateNAme
                    obj.value = obj?.StateId
                    return obj;
                }) ?? [];
                const regionData = countrystatecity?.data?.regionData?.map((obj: any) => {
                    obj.label = obj?.RegionName
                    obj.value = obj?.RegionId
                    return obj;
                }) ?? [];
                const countryData = countrystatecity?.data?.countryData?.map((obj: any) => {
                    obj.label = obj?.CountryName
                    obj.value = obj?.CountryId
                    return obj;
                }) ?? [];
                const subContinentData = countrystatecity?.data?.subContinentData?.map((obj: any) => {
                    obj.label = obj?.SubContinentName
                    obj.value = obj?.SubContinentId
                    return obj;
                }) ?? [];
                const continentData = countrystatecity?.data?.continentData?.map((obj: any) => {
                    obj.label = obj?.ContinentName
                    obj.value = obj?.ContinentId
                    return obj;
                }) ?? [];
                const genderData = countrystatecity?.data?.genderData?.map((obj: any) => {
                    obj.label = obj?.Gender
                    obj.value = obj?.GenderId
                    return obj;
                }) ?? [];

                return {
                    cityData: cityData,
                    stateData: stateData,
                    regionData: regionData,
                    countryData: countryData,
                    subContinentData: subContinentData,
                    continentData: continentData,
                    genderData: genderData
                }
            }
            else {
                return locations;
            }
        }
        catch (error) {
            return locations;
        }
    }
    else {
        return locations;
    }
}


export const SelectDropDownCheckboxInputOption = ({
    getStyles,
    Icon,
    isDisabled,
    isFocused,
    isSelected,
    children,
    innerProps,
    ...rest
}: any) => {
    const [isActive, setIsActive] = useState(false);
    const onMouseDown = () => setIsActive(true);
    const onMouseUp = () => setIsActive(false);
    const onMouseLeave = () => setIsActive(false);

    // styles
    let bg = "transparent";
    if (isFocused) bg = "#eee";
    if (isActive) bg = "#B2D4FF";

    const style = {
        alignItems: "center",
        backgroundColor: bg,
        color: "inherit",
        display: "flex "
    };

    // prop assignment
    const props = { ...innerProps, onMouseDown, onMouseUp, onMouseLeave, style };

    return (
        <components.Option
            {...rest}
            isDisabled={isDisabled}
            isFocused={isFocused}
            isSelected={isSelected}
            getStyles={getStyles}
            innerProps={props}
        >
            <span className='position-relative'>
                <input className='form-check-input dropdowncheckbox' type="checkbox" checked={isSelected} readOnly />
                <span className='dropdownvalue mx-2'>
                    {children}
                </span>
            </span>
        </components.Option>
    );
};

export function getDateCombination() {
    const today = new Date();
    const date =
        today?.getFullYear()?.toString() +
        (today?.getMonth() + 1)?.toString() +
        today?.getDate()?.toString();
    const time =
        today?.getHours()?.toString() +
        (today?.getMinutes() + 1)?.toString() +
        today?.getSeconds()?.toString();
    return date + "_" + time;
}

export const trimStrings = (obj: any) => {
    const updated = { ...obj };
    (Object.keys(updated)).forEach((key) => {
        if (typeof updated[key] === "string") {
            updated[key] = updated[key].trim();
        }
        else if (checkIsArray(updated[key]) && updated[key]?.length > 0) {
            updated[key] = updated[key]?.map((ele: any) => {
                if (checkIsPlainObject(ele) && Object.keys(ele)?.length > 0) {
                    ele = trimStrings(ele);
                }
                return ele;
            });
        }
        else if (checkIsPlainObject(updated[key]) && Object.keys(updated[key])?.length > 0) {
            updated[key] = trimStrings(updated[key]);
        }
    });

    return updated;
};


export const getuserprofileimagebyid = async () => {
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
        const userdata: any = GetLocalStorage()
        let UserId = userdata?.userMasterID;
        try {
            const userprofileimagebyid = await getAllData("/auth/v1/getuserprofileimagebyid?usermasterid=" + UserId);
            return userprofileimagebyid;
        }
        catch (error) {
            return null;
        }
    }
    else {
        return null;
    }
};



declare global {
    interface Window {
        fbq?: (...args: any[]) => void;
        gtag?: (...args: any[]) => void;
    }
}

export const trackLead = (): void => {
    if (typeof window === "undefined") return;

    if (window.fbq) {
        window.fbq("track", "Lead");
    }

    if (window.gtag) {
        window.gtag("event", "conversion", {
            send_to: "AW-16765278761/iRgSCIXM9fEaEKm0p7o-",
        });
    }
};

export const trackSearch = (): void => {
    if (typeof window === "undefined") return;

    if (window.fbq) {
        window.fbq("track", "Search");
    }
};

export const trackPurchase = (val: number): void => {
    if (typeof window === "undefined") return;

    if (window.fbq) {
        window.fbq("track", "Purchase", {
            value: val,
            currency: "INR",
        });
    }

    if (window.gtag) {
        window.gtag("event", "conversion", {
            send_to: "AW-16765278761/eTgpCILXprcbEKm0p7o-",
            value: val,
            currency: "INR",
        });
    }
};

export const fetchIp = async () => {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        return {
            status: true,
            data: data?.ip
        }
    } catch (error) {
        console.error('Error fetching IP address:', error);
        return {
            status: false,
            data: null
        }
    }
};

const airlineLogoCache = new Map();
export const getAirlineLogo = (airlineCode: any) => {
    if (airlineLogoCache.has(airlineCode)) return airlineLogoCache.get(airlineCode);
    const extensions = ['.gif', '.GIF', '.png', 'PNG', '.jpg', '.JPG', 'bmp', 'BPM', 'db', 'DB', 'jpeg', 'JPEG'];
    for (const ext of extensions) {
        try {
            const logo = require(`../../assets/img/flights/AirlineLogo/${airlineCode}${ext}`);
            airlineLogoCache.set(airlineCode, logo);
            return logo;
        } catch (e) { continue; }
    }
    const fallback = require("../../assets/img/no-image.png");
    airlineLogoCache.set(airlineCode, fallback);
    return fallback;
}

export const calculateDateDifference = (start: any, end: any) => {
    const date1 = new Date(start);
    const date2 = new Date(end);

    let years = date2.getFullYear() - date1.getFullYear();
    let months = date2.getMonth() - date1.getMonth();
    let days = date2.getDate() - date1.getDate();

    if (days < 0) {
        months--;
        const lastDayOfMonth = new Date(date2.getFullYear(), date2.getMonth(), 0).getDate();
        days = lastDayOfMonth + days;
    }

    if (months < 0) {
        years--;
        months = 12 + months;
    }

    return { years, months, days };
};


export const calculateDOB = (start: any, end: any, min = 0, max = 0, isMinAllowed = true, isMaxAllowed = true) => {
    // true indiacte that validation is occur
    let { years, months, days } = calculateDateDifference(start, end);

    let condition_1 = (!isMaxAllowed && !isMinAllowed)
        && ((years > min || (max > 0 && years < max))
            || (years === min && (days > 0 || months > 0))
            || (max > 0 && years === max && !(days > 0 || months > 0)))

    let condition_2 = (
        isMinAllowed ?
            years < max && (years >= min && (days >= 0 || months >= 0)) :
            years < max && (years >= min && (days > 0 || months > 0))
    )

    let condition_3 = (
        isMaxAllowed ?
            years > min && (years <= max && (days <= 0 && months <= 0)) :
            years > min && (years <= max && (days < 0 && months < 0))
    )

    if (condition_1 || condition_2 || condition_3) {
        return false;
    }
    else {
        return true;
    }
}


export function convertDurationToHM(duration: any, istotal: any, minutval = false) {
    if (istotal) {
        const layoverTimes = [];
        for (let i = 0; i < duration?.length - 1; i++) {
            const arrivalTime: any = new Date(duration[i].arrTime);
            const nextDepartureTime: any = new Date(duration[i + 1].depTime);
            const layoverDuration = nextDepartureTime - arrivalTime;
            if (layoverDuration > 0) {
                const totalMinutes = Math.floor(layoverDuration / (1000 * 60));
                layoverTimes?.push({
                    layover: totalMinutes,
                });
            }
        }
        const totalDuration = duration?.reduce((sum: any, flight: any) => sum + flight?.duration, 0);
        const totallayover = layoverTimes?.reduce((sum, flight) => sum + flight?.layover, 0);
        const hours = Math?.floor((totalDuration + totallayover) / 60);
        const minutes = (totalDuration + totallayover) % 60;
        if (minutval) {
            return totalDuration + totallayover
        }
        else {
            return `${hours}h ${minutes}m`;
        }
    }
    else {
        const totalDuration = duration?.reduce((sum: any, flight: any) => sum + flight?.duration, 0);
        const hours = Math?.floor((totalDuration) / 60);
        const minutes = totalDuration % 60;
        return `${hours}h ${minutes}m`;
    }
}

//#region get updated price or time of flight
export const getupdatedflightdetails = async (fligthBookingId = 162119, previousFlightBookingId = 0) => {
    try {
        const updatedflightdetails = await getAllData(`/customerui/v1/getupdatedflightdetails?fligthBookingId=${fligthBookingId}&previousFlightBookingId=${previousFlightBookingId}`)
        if (updatedflightdetails?.status) {
            return updatedflightdetails?.data ? updatedflightdetails?.data : null;
        }
        else {
            return null;
        }
    } catch (error) {
        return null;
    }
}
//#endregion

//#region for flight price summary
export const getPriceSummaryDetails = (updatedPrices: any = null, flightFareQouteData: any = null, isDomRtn = 0, forPax = false, paxType = 0) => {

    const isPriceChanged = updatedPrices?.response?.response?.isPriceChanged || false;
    if (forPax) {
        const newPrice = updatedPrices?.response?.response?.flightItinerary?.passenger
            ?.filter(((item: any) => item?.paxType === paxType))
            ?.reduce((acc: any, curr: any, index: any, arr: any) => {
                acc.baseFare = acc?.baseFare + curr?.fare?.baseFare;
                acc.passengerCount = arr?.length;
                return acc;
            }, { baseFare: 0, passengerCount: 0 })

        const PaxFareBreakdown = flightFareQouteData?.[isDomRtn]?.response?.results?.fareBreakdown?.find((fin: any) => fin?.passengerType === paxType);

        const cuurentPrice = {
            baseFare: PaxFareBreakdown?.baseFare || 0,
            passengerCount: PaxFareBreakdown?.passengerCount || 0
        }

        return isPriceChanged ? newPrice : cuurentPrice
    }
    else {
        const fareData = isPriceChanged ? updatedPrices?.response?.response?.flightItinerary?.fare : flightFareQouteData?.[isDomRtn]?.response?.results?.fare

        return {
            baseFare: fareData?.baseFare || 0,
            markupCharges: fareData?.markupCharges || 0,
            gstCharges: fareData?.gstCharges || 0,
            totalTaxAndSurcharges: fareData?.totalTaxAndSurcharges || 0,
            otherCharges: fareData?.otherCharges || 0,
            grandTotal: fareData?.grandTotal || 0,
        }
    }
}
//#endregion

export const hyphenateString = (str: any) => {
    return str
        ?.toLowerCase()
        ?.replace(/[^a-z0-9]+/g, '-')  // replace spaces + special chars with -
        ?.replace(/^-+|-+$/g, '');     // remove leading/trailing -
};